import includes from 'lodash/includes'
import without from 'lodash/without'
import constants from 'constants'

export function toggleDirection(direction) {
  if (includes(constants.SORT_DIRECTIONS, direction)) {
    return without(constants.SORT_DIRECTIONS, direction)[0]
  }
  return constants.SORT_DIRECTIONS[0]
}

export function defaultDirection() {
  return constants.SORT_DIRECTIONS[0]
}



// WEBPACK FOOTER //
// ./src/utils/sort.js